import React, {
  useEffect,
  useMemo,
  useRef,
  useState,
  useCallback,
} from "react";
import { connect } from "react-redux";
import { Col, Row } from "react-bootstrap";
import { useLocation, useNavigate } from "react-router-dom";
import { useDebouncedCallback } from "use-debounce";
import BarcodeReader from "react-barcode-reader";
import {
  routesPathConstants,
  buttonNameConstants,
  buttonTypeConstants,
  inventoryConstants,
  EMPTY_STRING,
  categoryDropdownConstants,
} from "../../../constants";
import Topbar from "../../../shared/components/topbar/Topbar";
import CategoriesDropdown from "../../../shared/components/selectDropdown/CategoriesDropdown";
import ServerPaginationTable from "../../../shared/components/agGrid/ServerPaginationTable";
import AGGridToolTip from "../../../shared/components/toolTipComponent/AGGridToolTip";
import ConfirmationModal from "../../../views/Inventory/Items/ConfirmationModal/ConfirmationModal";
import ProgressBar from "../../../shared/components/progressBar/ProgressBar";
import SelectDropDown from "../../../shared/components/selectDropdown/SelectDropdown";
import SearchField from "../../../shared/components/searchField/SearchField";
import SimpleTextArea from "../../../shared/components/inputTextArea/SimpleTextArea";
import { ToggleButtonWithText } from "../../../shared/components";

import {
  getStockAuditInventoryColumns,
  initializeLocalStorageValues,
  getConfirmCategoryCompletionHtml,
  getLocalStorageStockAuditObject,
  updateCountedQuantityOfObject,
  getConfirmCategoryCompletionHtmlTitle,
  getConfirmCategoryCompletionIncompleteHtml,
  getConfirmCategoryCompletionIncompleteHtmlTitle,
} from "../../../shared/utilities/columnHeadersUtility/stockAudit";
import { inventoryActions } from "../../../redux/actions";
import {
  getDurationString,
  isSpinnerEnabled,
  getRowStyle,
  getRowId,
  getDefaultFilterCategory,
  isButtonDisable,
  calculateBarWidth,
  LoadingIndicator,
  getReceiptPrintDate,
  prepareFilterForPaginationCall,
  getCustomSubCategoriesOptionList,
  upsertEditedItemToLocalStorage,
  parseToThousandSeperatorWholeNumber,
} from "../../../shared/utility";
import { defaultGridState } from "../../../constants";
import {
  EditIcon,
  TickIcon,
  CrossIcon,
  SearchIcon,
  BlueBoxIcon,
} from "../../../assets/icons/iconsProvider";
import {
  getItemFromLocalStorage,
  setItemToLocalStorage,
} from "../../../system/storage";
import { selectFieldStyleSmall } from "../../../assets/scss/style";
const StockAuditCategory = (props) => {
  const {
    spinnerArray,
    stockAuditInventory,
    currentStore,
    getAuditInventory,
    updateStockAuditCategory,
    itemOrganization,
    updateAuditInventory,
  } = props;

  const { customTypes, customCategories, customSubCategories } =
    itemOrganization;

  const { state } = useLocation();
  const { categoryState, categoryRow } = state;
  const navigate = useNavigate();
  const gridRef = useRef();
  const rowBeingEditRef = useRef({});
  const rowBeingEditParamRef = useRef({});
  const tooltipRef = useRef();
  const currentStoreRef = useRef(currentStore);

  const [localCategoryRow, setLocalCategoryRow] = useState({ ...categoryRow });
  const [gridState, setGridState] = useState(
    state?.gridState || defaultGridState
  );
  const [isConfirmationModal, setIsConfirmationModal] = useState(false);
  const [isCompletionConfirmationModal, setIsCompletionConfirmationModal] =
    useState(false);
  const [isZeroConfirmationModal, setIsZeroConfirmationModal] = useState(false);
  const [isInlineEditRefresh, setIsInlineEditRefresh] = useState(false);
  const [isEditingInline, setIsEditingInline] = useState(false);
  const [isScanned, setIsScanned] = useState(false);
  const [isScannedForSearch, setIsScannedForSearch] = useState(false);
  const [isEditNotes, setIsEditNotes] = useState(false);
  const [notes, setNotes] = useState(categoryRow.notes || "");
  const [isScanning, setIsScanning] = useState(true);
  const [gridData, setGridData] = useState(
    stockAuditInventory?.inventory || []
  );
  const [currentStatus, setCurrentStatus] = useState(categoryRow.status);
  const colDefs = useMemo(
    () =>
      getStockAuditInventoryColumns(
        rowBeingEditRef,
        setGridData,
        currentStatus
      ),
    [currentStatus, rowBeingEditRef, setGridData]
  );
  const [debouncedSearchText, setDebouncedSearchText] = useState(
    gridState?.searchQuery || EMPTY_STRING
  );
  const [searchProductSubCategory, setSearchProductSubCategory] = useState(
    getDefaultFilterCategory(customSubCategories, gridState?.productSubCategory)
  );
  const [isSearchLoading, setIsSearchLoading] = useState(false);
  const isLoadingGetAuditInventory = isSpinnerEnabled(spinnerArray, [
    inventoryConstants.GET_AUDIT_INVENTORY,
  ]);
  //this is used for carying the state when confirmation modal is shown on changing status
  const [categoryStatus, setCategoryStatus] = useState(
    inventoryConstants.STOCK_AUDIT_INVENTORY_STATUS_OPTIONS.find(
      (option) => option.value === categoryRow.status
    ).value
  );
  //the status selected
  const [defaultStatusOption, setDefaultStatusOption] = useState(
    inventoryConstants.STOCK_AUDIT_INVENTORY_STATUS_OPTIONS.find(
      (option) => option.value === categoryRow.status
    )
  );
  //the status options available
  const [defaultStatusAvailableOptions, setDefaultStatusAvailableOptions] =
    useState(
      inventoryConstants.STOCK_AUDIT_INVENTORY_STATUS_OPTIONS.filter(
        (option) => option.value !== defaultStatusOption?.value
      )
    );

  useEffect(() => {
    currentStoreRef.current = currentStore;
  }, [currentStore]);

  // This runs to UNLOCK the category when user navigates away
  useEffect(() => {
    return () => {
      // This runs when the component unmounts (navigating away)
      if (categoryRow?.id) {
        updateStockAuditCategory(
          currentStoreRef.current?.id, //currentStore?.id,
          categoryRow?.auditId,
          { ...categoryRow, isLocked: false },
          inventoryConstants.UNLOCK,
          navigate
        ); // Action to unlock category
      }
    };
  }, [categoryRow?.id]);

  // This runs to UNLOCK the category when user closes tab
  useEffect(() => {
    const handlePageHide = () => {
      if (categoryRow?.id) {
        updateStockAuditCategory(
          currentStoreRef.current?.id, //currentStore?.id,
          categoryRow?.auditId,
          { ...categoryRow, isLocked: false },
          inventoryConstants.UNLOCK
        ); // Action to unlock category
      }
    };
    window.addEventListener("pagehide", handlePageHide);
    return () => {
      window.removeEventListener("pagehide", handlePageHide);
    };
  }, [categoryRow?.id]);

  const clearSearchText = () => {
    handleSearchInputChange("");
  };

  const handleSearchInputChange = (value) => {
    setIsSearchLoading(true);
    setDebouncedSearchText(value);
    handleDebouncedSearch(value);
  };

  const handleDebouncedSearch = useDebouncedCallback((value) => {
    updateGridState({ ...gridState, searchQuery: value, pageIndex: 1 });
  }, 1000);

  const updateGridState = (gridState) => {
    getAuditInventory(
      currentStore?.id,
      categoryRow.auditId,
      categoryRow.categoryName,
      categoryRow.productTypeName,
      gridState,
      isScanned || isScannedForSearch || false
    );
    setGridData([]);
    setGridState(gridState);
  };

  // This useEffect runs when inventory being displayed on table changes, we get the items from local storage to get the items for which user has entered
  // some countedQuantites but those have not been saved to back-end yet, then isScanned is used to check if user had scanned a product because in that case
  // we need to automatically increase its quantity by 1
  useEffect(() => {
    let editedItems = [];
    try {
      const stored = getItemFromLocalStorage(inventoryConstants.STOCK_AUDIT);
      editedItems = stored ? JSON.parse(stored) : [];
    } catch (e) {
      editedItems = [];
    }

    // replacing the counted quantities present in local storage
    let hydratedGridData =
      stockAuditInventory?.inventory?.map((item) => {
        const edited = editedItems.find((e) => e.id === item.id);
        if (edited?.price?.countedQuantity != null) {
          return updateCountedQuantityOfObject(
            item,
            edited.price.countedQuantity
          );
        }
        return item;
      }) || [];

    // hanndling the scanning of product in that case increasing countedQuantity by 1
    if (isScanned) {
      let newItemsScanned = 0;
      hydratedGridData = hydratedGridData.map((item) => {
        if (item.price?.countedQuantity == null) {
          newItemsScanned += 1;
        }
        return updateCountedQuantityOfObject(
          item,
          (Number(item.price?.countedQuantity) || 0) + 1
        );
      });

      if (hydratedGridData && hydratedGridData.length > 0) {
        if (newItemsScanned > 0) {
          const storedCount =
            parseInt(
              getItemFromLocalStorage(
                inventoryConstants.STOCK_AUDIT_INVENTORY_UPDATED_COUNT
              )
            ) || 0;
          setItemToLocalStorage(
            inventoryConstants.STOCK_AUDIT_INVENTORY_UPDATED_COUNT,
            storedCount + newItemsScanned
          );
        }
        const storedDelta =
          parseInt(
            getItemFromLocalStorage(
              inventoryConstants.STOCK_AUDIT_INVENTORY_QUANTITY_DELTA
            )
          ) || 0;

        setItemToLocalStorage(
          inventoryConstants.STOCK_AUDIT_INVENTORY_QUANTITY_DELTA,
          storedDelta + 1
        );
        upsertEditedItemToLocalStorage(
          getLocalStorageStockAuditObject(
            hydratedGridData[0].id,
            hydratedGridData[0].price.countedQuantity
          ),
          inventoryConstants.STOCK_AUDIT
        );
      }
      setIsScanned(false);
    }
    setGridData(hydratedGridData);
    setGridState({
      ...gridState,
      totalRecords:
        stockAuditInventory?.totalRecords || defaultGridState.totalRecords,
      pageEndRecordNumber:
        stockAuditInventory?.pageEndRecordNumber ||
        defaultGridState.pageEndRecordNumber,
      pageStartRecordNumber:
        stockAuditInventory?.pageStartRecordNumber ||
        defaultGridState.pageStartRecordNumber,
    });
    setIsScannedForSearch(false);
    setIsSearchLoading(false);
  }, [stockAuditInventory]);

  const handleRefreshCells = (params) => {
    params.api.refreshCells({
      columns: [
        "id",
        "price.unit_sell_price",
        "price.unit_purchase_price",
        "price.quantity",
      ],
      rowNodes: [params.node],
      force: true,
    });
  };
  const redrawTopRows = useCallback((params) => {
    params.api.redrawRows({ rowNodes: [params.node] });
  }, []);
  const onCellClicked = useCallback((params) => {
    if (
      params.column.colId === "id" ||
      params.data.id === rowBeingEditRef?.current?.id
    ) {
    } else {
      if (rowBeingEditParamRef.current?.data?.id) {
        handleRefreshCells(rowBeingEditParamRef.current);
        redrawTopRows(rowBeingEditParamRef.current);
      }
      rowBeingEditParamRef.current = params;
      rowBeingEditRef.current = {
        ...params.data,
        originalQuantity: params.data.price.quantity,
        originalPrice: params.data.price.unit_sell_price,
      };
      handleRefreshCells(params);

      redrawTopRows(params);
    }
  }, []);

  const rowClassRules = useMemo(() => {
    return {
      // row style function
      "highlighted-row": (params) => {
        return (
          params?.data?.id && params?.data?.id === rowBeingEditRef.current?.id
        );
      },
    };
  }, []);

  const defaultColDef = useMemo(() => {
    if (isEditingInline) {
      setIsEditingInline(false);
      setIsInlineEditRefresh(true);
    }
    return {
      cellStyle: { display: "flex", alignItems: "center" },
      resizable: false,
      tooltipComponent: AGGridToolTip,
      headerTooltipComponent: AGGridToolTip,
      headerComponentParams: {
        gridState: gridState,
        updateGridState: updateGridState,
      },
    };
  }, [gridState]);

  useEffect(() => {
    if (currentStore?.id) {
      updateGridState({
        ...gridState,
        filters: prepareFilterForPaginationCall(
          EMPTY_STRING,
          EMPTY_STRING,
          searchProductSubCategory,
          EMPTY_STRING
        ),
        productSubCategory: searchProductSubCategory?.label,
      });
    }
  }, [currentStore, searchProductSubCategory]);

  // on the back navigation, if changes were made we ask user either he wants to save or discard them
  const handleBackNavigation = () => {
    let editedItems = [];
    try {
      const stored = getItemFromLocalStorage(inventoryConstants.STOCK_AUDIT);
      editedItems = stored ? JSON.parse(stored) : [];
    } catch (e) {
      editedItems = [];
    }

    if (editedItems.length > 0) {
      toggleConfirmationModal();
    } else {
      initializeLocalStorageValues();
      navigate(routesPathConstants.INVENTORY_ITEMS_STOCK_AUDIT_SESSION, {
        state: { currentAudit: categoryState.currentAudit },
      });
    }
  };

  // on changing the status if there are unfilled items we ask user should we make them 0 or ignore them
  const handleChangeStatus = (e) => {
    setCategoryStatus(e.value);
    if (e.value === buttonNameConstants.COMPLETED) {
      if ((countedItems || 0) === (categoryRow.totalItems || 0)) {
        toggleCompletionConfirmationModal();
      } else {
        toggleZeroConfirmationModal();
      }
    } else {
      updateStatusOfCategory(false, e.value);
    }
  };

  const toggleCompletionConfirmationModal = () => {
    setIsCompletionConfirmationModal(!isCompletionConfirmationModal);
  };

  const handleCompletionConfirmNoButtonClick = () => {
    toggleCompletionConfirmationModal();
  };

  const handleCompletionConfirmYesButtonClick = () => {
    updateStatusOfCategory();
    toggleCompletionConfirmationModal();
  };

  const toggleZeroConfirmationModal = () => {
    setIsZeroConfirmationModal(!isZeroConfirmationModal);
  };

  const handleZeroCancelButtonClick = () => {
    toggleZeroConfirmationModal();
  };

  // in case the user selects to update quantites to 0 or ignore when he tries to complete a category, we set the items that are being currrently shown
  // and then we make a request to back-end with these updated values and any unsaved values tthat user had before, then back-end sets all the items accoeding to
  // operation we had set
  const handleZeroButtonClicksUpdateValues = (operation) => {
    let updatedGridData;
    let updatedGridDataComplete;
    if (operation === buttonNameConstants.IGNORE_ITEMS) {
      updatedGridData = gridData
        .filter((item) => !item.price?.countedQuantity)
        .map((item) =>
          getLocalStorageStockAuditObject(
            item.id,
            (item.price?.quantity || 0) + (item.price?.onlineQuantity || 0)
          )
        );
      updatedGridDataComplete = gridData.map((item) =>
        updateCountedQuantityOfObject(
          item,
          item.price?.countedQuantity ||
            (item.price?.quantity || 0) + (item.price?.onlineQuantity || 0) ||
            0
        )
      );
    } else {
      updatedGridData = gridData
        .filter((item) => !item.price?.countedQuantity)
        .map((item) => getLocalStorageStockAuditObject(item.id, 0));
      updatedGridDataComplete = gridData.map((item) =>
        updateCountedQuantityOfObject(item, item.price?.countedQuantity || 0)
      );
    }
    const localStorageData = getItemFromLocalStorage(
      inventoryConstants.STOCK_AUDIT
    );

    initializeLocalStorageValues();
    setGridData(updatedGridDataComplete);

    updateAuditInventory(
      currentStore?.id,
      categoryRow.auditId,
      categoryRow.categoryName,
      categoryRow.productTypeName,
      [...JSON.parse(localStorageData || "[]"), ...updatedGridData],
      null,
      null,
      operation,
      setLocalCategoryRow
    );
    toggleZeroConfirmationModal();
    toggleCompletionConfirmationModal();
  };
  const handleZeroIgnoreButtonClick = () => {
    handleZeroButtonClicksUpdateValues(buttonNameConstants.IGNORE_ITEMS);
  };

  const handleZeroButtonClick = () => {
    handleZeroButtonClicksUpdateValues(buttonNameConstants.ZERO_ITEMS);
  };

  const updateStatusOfCategory = (readState = true, statusValue) => {
    setDefaultStatusAvailableOptions(
      inventoryConstants.STOCK_AUDIT_INVENTORY_STATUS_OPTIONS.filter(
        (option) => option.value !== (readState ? categoryStatus : statusValue)
      )
    );
    setDefaultStatusOption(
      inventoryConstants.STOCK_AUDIT_INVENTORY_STATUS_OPTIONS.filter(
        (option) => option.value === (readState ? categoryStatus : statusValue)
      )
    );
    if (
      (readState ? categoryStatus : statusValue) ===
      buttonNameConstants.COMPLETED
    ) {
      const updatedData = getItemFromLocalStorage(
        inventoryConstants.STOCK_AUDIT
      );

      updateAuditInventory(
        currentStore?.id,
        categoryRow.auditId,
        categoryRow.categoryName,
        categoryRow.productTypeName,
        updatedData,
        null,
        null,
        buttonNameConstants.COMPLETED
      );

      setItemToLocalStorage(inventoryConstants.STOCK_AUDIT, JSON.stringify([]));
      setCurrentStatus(buttonNameConstants.COMPLETED);
    } else {
      updateStockAuditCategory(
        currentStore?.id,
        categoryRow?.auditId,
        {
          ...categoryRow,
          status: buttonNameConstants.IN_PROGRESS,
        },
        ""
      );
      setCurrentStatus(buttonNameConstants.IN_PROGRESS);
    }
  };

  const toggleConfirmationModal = () => {
    setIsConfirmationModal(!isConfirmationModal);
  };

  const handleConfirmNoButtonClick = () => {
    toggleConfirmationModal();
  };

  const handleConfirmDiscardButtonClick = () => {
    toggleConfirmationModal();
    initializeLocalStorageValues();
    navigate(routesPathConstants.INVENTORY_ITEMS_STOCK_AUDIT_SESSION, {
      state: { currentAudit: categoryState.currentAudit },
    });
  };

  const handleConfirmYesButtonClick = () => {
    handleSaveAndExit();
    toggleConfirmationModal();
  };

  const handleSaveAndExit = () => {
    const updatedData = getItemFromLocalStorage(inventoryConstants.STOCK_AUDIT);
    updateAuditInventory(
      currentStore?.id,
      categoryRow.auditId,
      categoryRow.categoryName,
      categoryRow.productTypeName,
      updatedData,
      navigate,
      categoryState.currentAudit
    );
    initializeLocalStorageValues();
  };

  // for counted Items and quantity we use localCategoryRow, it is because it might be updated when user update the quantities via setting them to zero or ignore
  // when changing the status, so at that time we get a updated response
  const countedItems = useMemo(() => {
    return (
      localCategoryRow.itemsAudited +
      (parseInt(
        getItemFromLocalStorage(
          inventoryConstants.STOCK_AUDIT_INVENTORY_UPDATED_COUNT
        )
      ) || 0)
    );
  }, [gridData, localCategoryRow]);
  const countedQuantity = useMemo(() => {
    return (
      localCategoryRow.countedQuantity +
      (parseInt(
        getItemFromLocalStorage(
          inventoryConstants.STOCK_AUDIT_INVENTORY_QUANTITY_DELTA
        )
      ) || 0)
    );
  }, [gridData, localCategoryRow]);

  const handleIsScanningChange = (e) => {
    setIsScanning(e);
  };
  //-------handle scan
  const handleScan = (data) => {
    if (isScanning === true) {
      setIsScanned(true);
      handleSearchInputChange(data);
    } else {
      setIsScannedForSearch(true);
      handleSearchInputChange(data);
    }
  };
  //-------handle scan error
  const handleError = (error) => {};

  // changing the notes clicking edit
  const handleEditNotesClick = () => {
    setIsEditNotes(true);
  };
  // changing the notes clicking confirm
  const handleTickNotesClick = () => {
    updateStockAuditCategory(
      currentStore?.id,
      categoryRow?.auditId,
      {
        ...categoryRow,
        notes: notes,
      },
      "",
      null,
      true
    );
    setIsEditNotes(false);
  };
  // changing the notes clicking cancel
  const handleCrossNotesClick = () => {
    setIsEditNotes(false);
  };

  const skeletonArray = Array(10).fill({});
  return (
    <>
      <div>
        <BarcodeReader onError={handleError} onScan={handleScan} />
      </div>
      <Topbar
        title={`Category Audit`}
        backNavigation={{
          isVisible: true,
          route: routesPathConstants.INVENTORY_ITEMS_STOCK_AUDIT_SESSION,
          currentAudit: categoryState.currentAudit,
          onBackNavigation: handleBackNavigation,
        }}
        isAuditSaveButton={{
          isVisible: true,
          handleButtonClick: handleSaveAndExit,
          buttonLabel: buttonNameConstants.SAVE_AND_EXIT,
        }}
      ></Topbar>
      <Row className="m-0">
        <Col md={6}>
          <Row className="m-0">
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span className="predefinded-audit-label">Category</span>
            </Col>
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span>{categoryRow.categoryName}</span>
            </Col>
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span className="predefinded-audit-label">Type</span>
            </Col>
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span>{categoryRow.productTypeName}</span>
            </Col>
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span className="predefinded-audit-label">Status</span>
            </Col>
            <Col md={2} className="mb-3 d-flex align-items-center">
              <div className="align-items-center gap-2">
                <SelectDropDown
                  options={defaultStatusAvailableOptions}
                  menuPlacement="bottom"
                  defaultPageSize={defaultStatusOption}
                  value={defaultStatusOption}
                  handleChange={(e) => {
                    handleChangeStatus(e);
                  }}
                  styles={selectFieldStyleSmall}
                />
              </div>
            </Col>
          </Row>

          <Row className="m-0">
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span className="predefinded-audit-label">Start Date</span>
            </Col>
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span>{getReceiptPrintDate(categoryRow.startDate, true)}</span>
            </Col>
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span className="predefinded-audit-label">Duration</span>
            </Col>
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span>
                {getDurationString(categoryRow.startDate, categoryRow.endDate)}
              </span>
            </Col>

            <Col md={2} className="mb-3 d-flex align-items-center">
              <span className="predefinded-audit-label">Total Items</span>
            </Col>
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span>
                {parseToThousandSeperatorWholeNumber(
                  categoryRow.totalItems || 0
                )}
              </span>
            </Col>
          </Row>
          <Row className="m-0">
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span className="predefinded-audit-label">Started By</span>
            </Col>
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span>{categoryRow.startedBy}</span>
            </Col>
            <Col md={2} className="mb-3 d-flex align-items-center"></Col>
            <Col md={2} className="mb-3 d-flex align-items-center"></Col>
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span className="predefinded-audit-label">Total Quantity</span>
            </Col>
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span>
                {parseToThousandSeperatorWholeNumber(
                  categoryRow.totalQuantity || 0
                )}
              </span>
            </Col>
          </Row>
        </Col>
        <Col md={3}>
          <Row className="m-0">
            <Col md={12} className="mb-3 d-flex align-items-center">
              <span className="predefinded-audit-label">Audit Progress</span>
            </Col>
          </Row>
          <Row className="m-0 mt-2">
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span className="predefinded-audit-label">Items</span>
            </Col>
            <Col md={10} className="mb-3 d-flex align-items-center">
              <ProgressBar
                min={0}
                max={categoryRow.totalItems || 0}
                label={`${countedItems || 0} of ${categoryRow.totalItems || 0}`}
                current={countedItems || 0}
                percentage={calculateBarWidth(
                  categoryRow.totalItems || 0,
                  countedItems || 0
                )}
                barWrapper={true}
              />
            </Col>
          </Row>
          <Row className="m-0">
            <Col md={2} className="mb-3 d-flex align-items-center">
              <span className="predefinded-audit-label">Quantity</span>
            </Col>
            <Col md={10} className="mb-3 d-flex align-items-center">
              <ProgressBar
                min={0}
                max={categoryRow.totalQuantity || 0}
                label={`${countedQuantity || 0} of ${
                  categoryRow.totalQuantity || 0
                }`}
                current={countedQuantity || 0}
                percentage={calculateBarWidth(
                  categoryRow.totalQuantity || 0,
                  countedQuantity || 0
                )}
                barWrapper={true}
              />
            </Col>
          </Row>
        </Col>
        <Col md={3}>
          <Row className="m-0">
            <Col
              md={12}
              className="mb-3 d-flex align-items-center justify-content-between"
            >
              <span className="predefinded-audit-label">Notes</span>
              {isEditNotes ? (
                <div className="mt-1 d-flex gap-2">
                  <button
                    className="action-Button-Wrapper ps-0 pe-0"
                    onClick={() => {
                      handleCrossNotesClick();
                    }}
                  >
                    <CrossIcon className="cursor-pointer" />
                  </button>
                  <button
                    className="action-Button-Wrapper ps-0 pe-0"
                    onClick={() => {
                      handleTickNotesClick();
                    }}
                  >
                    <TickIcon className="cursor-pointer text-primary" />
                  </button>
                </div>
              ) : (
                <button
                  className="action-Button-Wrapper ps-0 pe-0"
                  onClick={() => {
                    handleEditNotesClick();
                  }}
                >
                  <EditIcon className="cursor-pointer text-muted" />
                </button>
              )}
            </Col>
          </Row>
          <Row className="m-0">
            <Col md={12} className="d-flex flex-column">
              <SimpleTextArea
                isDisabled={!isEditNotes}
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeHolder="Enter Notes"
                isSmall={true}
                maxLength={1000}
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row className="m-0 mb-2 ms-4">
        <div className="col-sm-6 px-0 topbar-title-container">
          <span className="audit-label">
            Audit: {categoryRow.categoryName} ({categoryRow.productTypeName})
          </span>
        </div>
      </Row>
      <Row className="m-0">
        <Col md={6} className="">
          <SearchField
            isFocus={true}
            onChange={(e) => handleSearchInputChange(e.target.value)}
            IconImage={SearchIcon}
            placeHolder="Search Item Name, UPC or SKU"
            value={debouncedSearchText}
            CrossIcon={debouncedSearchText ? CrossIcon : ""}
            clearSearchText={clearSearchText}
            BlueBoxIcon={BlueBoxIcon}
            LoadingIndicator={
              (isSearchLoading && isLoadingGetAuditInventory) ||
              isButtonDisable(
                spinnerArray,
                inventoryConstants.GET_ALL_INVENTORY
              )
                ? LoadingIndicator
                : false
            }
          />
        </Col>
        <Col md={2} className="justify-content-end align-items-end gap-3">
          <CategoriesDropdown
            options={getCustomSubCategoriesOptionList(
              customSubCategories,
              categoryRow.categoryId,
              categoryRow.productTypeName,
              categoryRow.productTypeId,
              false,
              customCategories
            )}
            label="Sub-Category"
            value={searchProductSubCategory}
            handleChange={(selectedOption) => {
              setSearchProductSubCategory(selectedOption || EMPTY_STRING);
            }}
            noOptionsMessage="No SubCategory Found"
            placeholder="Sub-Category"
            wrapperClassname="category-dropdowns-moveup"
            SelectIconImage={categoryDropdownConstants.DEFAULT_ICON}
          />
        </Col>
        <Col md={4}>
          <Row className="m-0">
            <Col
              md={2}
              className="d-flex justify-content-center align-items-center"
            >
              <span>Scanner Mode:</span>
            </Col>
            <Col
              md={4}
              className="d-flex justify-content-start align-items-center"
            >
              <ToggleButtonWithText
                isToggle={!isScanning}
                handleLeftButtonClick={() => {
                  handleIsScanningChange(true);
                }}
                handleRightButtonClick={() => {
                  handleIsScanningChange(false);
                }}
                leftButtonLabel="Scan"
                rightButtonLabel="Search Only"
                className="discount-toggle-button audit-inventory-scanning-toggle-switch"
              />
            </Col>
          </Row>
        </Col>
      </Row>
      <Row
        className="m-0 w-100 h-100 user-screen-wrapper pt-3"
        onMouseLeave={() => {
          tooltipRef.current?.close();
        }}
      >
        <ServerPaginationTable
          colDefs={colDefs}
          gridRef={gridRef}
          gridData={
            isSpinnerEnabled(spinnerArray, [
              inventoryConstants.GET_AUDIT_INVENTORY,
            ])
              ? skeletonArray
              : gridData
          }
          getRowId={getRowId}
          gridState={gridState}
          getRowStyle={getRowStyle}
          onCellClicked={onCellClicked}
          rowClassRules={rowClassRules}
          defaultColDef={defaultColDef}
          updateGridState={updateGridState}
          paginationPageSize={gridState.pageSize}
          pageSizeOptions={gridState.pageSizeOptions}
          tableHeight={`calc(100vh - ${"315"}px)`}
          isDataLoading={isSpinnerEnabled(spinnerArray, [
            inventoryConstants.GET_AUDIT_INVENTORY,
          ])}
          isInlineEditRefresh={isInlineEditRefresh}
          setIsInlineEditRefresh={setIsInlineEditRefresh}
        />
      </Row>
      <ConfirmationModal
        isConfirmationModal={isConfirmationModal}
        handleNoButtonClick={handleConfirmNoButtonClick}
        handleYesButtonClick={handleConfirmYesButtonClick}
        toggleConfirmationModal={toggleConfirmationModal}
        isDiscardButton={true}
        handleDiscardButtonClick={handleConfirmDiscardButtonClick}
        noButtonText={buttonNameConstants.CANCEL}
        yesButtonText={buttonNameConstants.SAVE_AND_EXIT}
        discardButtonText={buttonNameConstants.DISCARD_AND_EXIT}
        message={`You have unsaved changes to the ${categoryRow.categoryName} audit. Would you like to continue?`}
      />
      <ConfirmationModal
        isConfirmationModal={isCompletionConfirmationModal}
        handleNoButtonClick={handleCompletionConfirmNoButtonClick}
        handleYesButtonClick={handleCompletionConfirmYesButtonClick}
        toggleConfirmationModal={toggleCompletionConfirmationModal}
        noButtonText={buttonNameConstants.CANCEL}
        yesButtonText={buttonNameConstants.COMPLETE}
        isHtmlMessage={true}
        message={getConfirmCategoryCompletionHtml()}
        isLoading={isSpinnerEnabled(spinnerArray, [
          inventoryConstants.UPDATE_AUDIT_INVENTORY,
        ])}
        title={getConfirmCategoryCompletionHtmlTitle()}
      />
      <ConfirmationModal
        size={"lg"}
        isConfirmationModal={isZeroConfirmationModal}
        handleNoButtonClick={handleZeroCancelButtonClick}
        handleYesButtonClick={handleZeroButtonClick}
        handleDiscardButtonClick={handleZeroIgnoreButtonClick}
        toggleConfirmationModal={toggleZeroConfirmationModal}
        isDiscardButton={true}
        noButtonText={buttonNameConstants.CANCEL}
        yesButtonText={buttonNameConstants.ZERO_ITEMS}
        discardButtonText={buttonNameConstants.IGNORE_ITEMS}
        yesButtonType={buttonTypeConstants.RED_BUTTON_FILL}
        isHtmlMessage={true}
        message={getConfirmCategoryCompletionIncompleteHtml(
          `${categoryRow.categoryName} (${categoryRow.productTypeName})`,
          categoryRow.totalItems || 0,
          countedItems || 0
        )}
        title={getConfirmCategoryCompletionIncompleteHtmlTitle()}
      />
    </>
  );
};

const mapStateToProps = (state) => ({
  spinnerArray: state.system.spinnerArray,
  stockAuditInventory: state.inventory.stockAuditInventory,
  currentStore: state.store.currentStore,
  itemOrganization: state.itemOrganization,
});

//-------Mapping the component's props to the related actions
const mapDispatchToProps = (dispatch) => ({
  updateStockAuditCategory: (
    storeId,
    auditId,
    data,
    operation,
    navigate,
    updateNotes
  ) =>
    dispatch(
      inventoryActions.updateStockAuditCategory(
        storeId,
        auditId,
        data,
        operation,
        navigate,
        null,
        updateNotes
      )
    ),
  getAuditInventory: (
    storeId,
    auditId,
    categoryName,
    productTypeName,
    gridState,
    isScanned
  ) =>
    dispatch(
      inventoryActions.getAuditInventory(
        storeId,
        auditId,
        categoryName,
        productTypeName,
        gridState,
        isScanned
      )
    ),

  updateAuditInventory: (
    storeId,
    auditId,
    categoryName,
    productTypeName,
    data,
    navigate,
    currentAudit,
    operation,
    setLocalCategoryRow
  ) =>
    dispatch(
      inventoryActions.updateAuditInventory(
        storeId,
        auditId,
        categoryName,
        productTypeName,
        data,
        navigate,
        currentAudit,
        operation,
        setLocalCategoryRow
      )
    ),
});

//-------Export AddInvoice Component
export default connect(mapStateToProps, mapDispatchToProps)(StockAuditCategory);
